import React from 'react';


const ModalHeader = ({ text }) => {
    return (
        <div className='w-full h-fit flex justify-between relative items-center mt-5'>
            <p className='text-[#0987F3] uppercase text-xl ml-12 font-semibold bg-white z-20 px-4 mobile:text-sm mobile:px-0 mobile:w-full mobile:text-center mobile:ml-0'>{text}</p>
            <hr className='w-full h-0.5 bg-[#0987F3] absolute z-10 mobile:hidden' />
        </div>
    );
}

export default ModalHeader;